
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/puzzles",
      function () {
        return require("private-next-pages/puzzles/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/puzzles"])
      });
    }
  